module.exports = __webpack_public_path__ + "static/media/eau-tendre.2ec1cb4a.png";